import { generalContent } from "./Content/General";
import { importantContent } from "./Content/Important";
import { multiSenderContent } from "./Content/MultiSender";
import { presaleContent } from "./Content/Presale";
import { fairLaunchContent } from "./Content/FairLaunch";
import { airdropContent } from "./Content/Airdrop";
import { trendLockContent } from "./Content/TrendLock";

export const docsContent = {
  ...generalContent,
  ...importantContent,
  ...multiSenderContent,
  ...presaleContent,
  ...fairLaunchContent,
  ...airdropContent,
  ...trendLockContent,
};

export const docsNavigation = [
  {
    category: "",
    items: [
      { id: "introduction", label: "Introduction" },
      { id: "token_metrics", label: "Token Metrics" },
      { id: "service_fees", label: "Service Fees" },
    ],
  },
  {
    category: "Important",
    items: [
      { id: "contact_us", label: "Contact Us" },
      { id: "social_links", label: "Social Links" },
      { id: "terms_of_service", label: "Terms of Service" },
      { id: "privacy_policy", label: "Privacy Policy" },
    ],
  },
  {
    category: "SERVICES",
    items: [], // Header only
  },
  {
    category: "MULTI-SENDER",
    items: [{ id: "how_to_use_multisender", label: "How to Use Multi-Sender" }],
  },
  {
    category: "PRESALE",
    items: [
      { id: "create_presale", label: "Create a Presale" },
      { id: "update_presale", label: "Update a Presale" },
      { id: "finalize_presale", label: "Finalize a Presale" },
      { id: "cancel_presale", label: "Cancel a Presale" },
      { id: "add_remove_whitelists", label: "Add/Remove Whitelists" },
      { id: "whitelist_tiers", label: "Whitelist Tiers" },
      { id: "team_vesting", label: "Team Vesting" },
      { id: "presale_vesting", label: "Presale Vesting" },
    ],
  },
  {
    category: "FAIR LAUNCH",
    items: [
      { id: "create_fair_launch", label: "Create a Fair Launch" },
      { id: "finalize_fair_launch", label: "Finalize a Fair Launch" },
      { id: "fair_launch_buy_back", label: "Fair Launch Buy-Back Option" },
    ],
  },
  {
    category: "AIRDROP",
    items: [
      { id: "create_airdrop", label: "Create New Airdrop" },
      { id: "claim_airdrop", label: "Claim Airdrop" },
    ],
  },
  {
    category: "TRENDLOCK",
    items: [
      { id: "create_lock", label: "Create a Lock" },
      { id: "update_lock", label: "How to Update the Lock" },
      { id: "how_to_unlock", label: "How to Unlock" },
      { id: "transfer_lock_ownership", label: "Transfer Lock Ownership" },
    ],
  },
];
